import React from 'react'
import SmartviewSlideinSidebar from 'widgets/smartviews/partials/SmartviewSlideinSidebar'

export default function SlideInSmartviewContainer (props) {
  return (
    <>
      <SmartviewSlideinSidebar hiddenIfEmpty>
        {props.children}
      </SmartviewSlideinSidebar>
    </>
  )
}
